import { getServiceUrl } from '../api'
import RequestService from '../httpRequest'

function request({ url, method = 'GET', data, formData = false }, callback, failCallback) {
  const builder = RequestService.sendRequest()
    .url(`${getServiceUrl()}${url}`)
    .method(method)

  if (formData) {
    // Leave Content-Type unset so the browser supplies the multipart boundary.
    builder.header({})
  }
  if (data !== undefined) {
    builder.data(data)
  }

  builder
    .success((res) => {
      RequestService.clearRequestTime()
      callback(res)
    })
  if (typeof failCallback === 'function') {
    builder.fail((res) => failCallback(res))
  }
  builder
    .networkFail((res) => {
      if (typeof failCallback === 'function') {
        failCallback(res)
        return
      }
      RequestService.reAjaxFun(() => request({ url, method, data, formData }, callback))
    })
    .send()
}

export default {
  page(params, callback, failCallback) {
    request({ url: '/emotion-pack', data: params }, callback, failCallback)
  },
  get(id, callback, failCallback) {
    request({ url: `/emotion-pack/${id}` }, callback, failCallback)
  },
  create(formData, callback, failCallback) {
    request({ url: '/emotion-pack', method: 'POST', data: formData, formData: true }, callback, failCallback)
  },
  createBase(formData, callback, failCallback) {
    request({ url: '/emotion-pack/base', method: 'POST', data: formData, formData: true }, callback, failCallback)
  },
  publish(id, deviceIds, callback, failCallback) {
    request({ url: `/emotion-pack/${id}/publish`, method: 'POST', data: { deviceIds } }, callback, failCallback)
  },
  rollback(id, previousPackId, deviceIds, callback, failCallback) {
    request({
      url: `/emotion-pack/${id}/rollback`,
      method: 'POST',
      data: { previousPackId, deviceIds }
    }, callback, failCallback)
  },
  refreshDeliveries(id, callback, failCallback) {
    request({ url: `/emotion-pack/${id}/deliveries/refresh`, method: 'POST', data: {} }, callback, failCallback)
  }
}
